<template>
  <div class="item-wrapper">
    <div v-if="item" :ref="`item-${index}`" class="item">
      <div class="item-mask">
        <div class="item-delete" @click="handleDelete">
          <bcc-icon
            type="ic_Systemerror"
            color="#f4f4f4"
            size="22px"
          ></bcc-icon>
        </div>
      </div>
      <div
        v-if="item.status === 'success'"
        class="item-content"
        :style="{ backgroundImage: `url(${item.url})` }"
      ></div>
      <div v-if="item.status === 'pending'" class="item-content item-pending">
        <div class="item-pending-bar"></div>
        <div class="item-pending-text">等待上传</div>
      </div>
      <div v-if="item.status === 'failed'" class="item-content item-failed">
        <div class="item-delete" @click.stop="handleDelete"></div>
        <div class="item-failed-icon">
          <bcc-icon
            type="ic_Systemerror"
            color="#fa5a57"
            size="48px"
          ></bcc-icon>
        </div>
        <div class="item-failed-text">上传失败</div>
      </div>
    </div>
    <div class="item-title">
      {{ item.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'list-item',
  props: ['item', 'index'],
  methods: {
    upload () {},
    handleDelete () {
      this.$emit('delete', { index: this.index })
    }
  }
}
</script>
